import { defineStore } from 'pinia'
import { ref } from 'vue'
import ApplicationTheme from 'src/models/application-theme/ApplicationTheme'

export const useApplicationThemeStore = defineStore('application-theme', () => {
  const ApplicationTheme = ref<ApplicationTheme>()

  return { ApplicationTheme }
})
